import { Cookies } from 'react-cookie';

import { StartVisitTimerFormValues } from './type';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface StartTimerInterface {
  startVisitData: StartVisitTimerFormValues;
  id: string;
  slug: string;
}

// Створення POST # 2 " Fetch на енд-поінт АРІ " | Start Block |

export const startVisitTimerFetch = async ({ startVisitData, id, slug }: StartTimerInterface) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.post(
    `/visit_report/${slug}/${id}/start-timer/`,
    {
      ...startVisitData,
    },
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return data.data as any;
};

// Створення POST # 2 " Fetch на енд-поінт АРІ " | End Block |
